module.exports = __webpack_public_path__ + "static/media/arrow-down-white.a1af429b.svg";